import { GenAlgRunTable } from './GenAlgRunTable';
import { Box, Button, Typography } from '@mui/material';

const GenAlgRuns = () => {

    const CreateGenAlgRunButton = () =>
        <Button
            sx={{ marginLeft: '20px' }}
            variant="contained"
            href={"create-gen-alg-run"}
        >
            CREATE GEN ALG RUN
        </Button>
    return (
        <div>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <Box>
                    <Typography variant="h6">Genetic Algorithm Runs</Typography>
                </Box>
                <Box>
                    <CreateGenAlgRunButton />
                </Box>
            </Box>
            <GenAlgRunTable parent_id={undefined} />
        </div>
    )
}

export default GenAlgRuns;